import { createAction, props } from '@ngrx/store';
import { UserState } from './state';

export const LoadUser = createAction(
  '[User] Load User'
)

export const SetUser = createAction(
  '[User] Set User',
  props<{ user: UserState }>()
)

